import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CTADirective } from "@rig/ng-buttons";
import { SelectableCardComponent, SingleSelectGroupComponent, SelectableDirective } from "@rig/ng-forms";
import { TextStyleDirective } from "@rig/ng-typography";
import { environment } from "../../../environments/environment";
import { CCPAParams } from "@prequalification/models";
import {
  ProductService,
  RbcTagManagerService,
  GA4View,
  PageEventDetails,
  STEP_PAGES,
  GAPageMapping
} from "@prequalification/services";

@Component({
  selector: "riam",
  templateUrl: "./riam.component.html",
  styleUrls: ["./riam.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    SelectableCardComponent,
    SingleSelectGroupComponent,
    SelectableDirective,
    TextStyleDirective,
    CTADirective
  ]
})
export class RiamComponent implements OnInit {
  existingProfileYes = 'yes';
  existingProfileNo = 'no';
  existingProfileSelection = this.existingProfileYes;

  constructor(private productService: ProductService, private gaService: RbcTagManagerService) {}

  ngOnInit(): void {
    this.sendGAEvent();
  }

  onSelectedItemChange($event) {
    this.existingProfileSelection = $event;
  }

  sendGAEvent() {
    const data: PageEventDetails = {
      pageName: STEP_PAGES.RIAMSIGNIN,
      product: this.productService.chnl,
      cardType: this.productService.pid
    };
    const event: GA4View = {
      page_title: GAPageMapping[data.pageName].pageTitle
    };

    this.gaService.sendGtmPageView(event);
    this.gaService.sendGAProgressCheckoutEvent(data);
  }

  riamSignUp() {
    const riamUrlWithParams = new URL(environment.riamLoginUrl);
    riamUrlWithParams.searchParams.append("request_type", "registration,login");
    this.appendCommonsParams(riamUrlWithParams);
    window.location.href = decodeURIComponent(riamUrlWithParams.href);
  }

  olbSignIn() {
    const ccpaUrlWithParams = new URL(environment.ccpaUrl);
    this.appendCommonsParams(ccpaUrlWithParams);
    // Please do not touch this :(... This is duplicated because encodeURIComponent controls the redirect back to our app
    // Then the duplicated strings after controls giving OLB the proper language information
    window.location.href =
      environment.olbLoginUrl +
      encodeURIComponent(ccpaUrlWithParams.href) +
      `chnl=${this.productService.chnl}&lang=${this.productService.lang}`;
  }

  appendCommonsParams(url: URL) {
    url.searchParams.append(CCPAParams.CHANNEL_PARAM, this.productService.chnl);
    url.searchParams.append(CCPAParams.PID_PARAM, this.productService.pid.toUpperCase());
    url.searchParams.append(CCPAParams.CAMPAIGN_CODE_PARAM, this.productService.campaignCode);
    url.searchParams.append(CCPAParams.LANGUAGE, this.productService.lang);
  }

  continue() {
    if (this.existingProfileSelection === this.existingProfileYes) {
      this.olbSignIn();
      return;
    }
    this.riamSignUp();
  }
}
